module.exports = __webpack_public_path__ + "img/map-sxms.6a51985f.png";